import { useCallback, useRef } from 'react';

export const useThrottledPrefetch = (
  trigger: () => void,
  delay: number = 100,
) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const timeout = setTimeout(trigger, delay);
    timeoutRef.current = timeout;
  }, [trigger, delay]);

  const handleMouseLeave = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  return {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  };
};
